import { DialogActions, Button, Box } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GenericDialog } from 'src/shared/components/organisms/genericDialog';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { getMemberById } from 'src/shared/services/memberService';
import { Member } from '../models/member';
import { MemberProfiles } from './memberProfiles';

export type MemberAddProfileDialogProps = {
  memberId: string;
  open: boolean;
  onClose: () => void;
};

export const MemberAddProfileDialog = (props: MemberAddProfileDialogProps) => {
  const { open, onClose, memberId } = props;
  const { t } = useTranslation(['common', 'member']);
  const isMounted = useIsMounted();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showAddProfile, setShowAddProfile] = useState<boolean>(false);
  const [member, setMember] = useState<Member>();

  const fetchData = useCallback(
    async (uid: string) => {
      setIsLoading(true);
      try {
        const result = await getMemberById(uid);
        if (isMounted()) {
          setMember(result.data);
          ConsoleHelper.log('RES member', result.data);
        }
      } catch (err) {
        if (isMounted()) {
          ConsoleHelper.log(err);
        }
      } finally {
        if (isMounted()) {
          setIsLoading(false);
        }
      }
    },
    [isMounted],
  );

  useEffect(() => {
    fetchData(memberId);
  }, [memberId, fetchData]);

  return (
    <GenericDialog
      open={open}
      onClose={onClose}
      onSave={onClose}
      showDividers={false}
      dialogTitle={t('member:addProfilesToMember')}
      dialogContent={
        <>
          {showAddProfile && member && (
            <Box sx={{ py: 3 }}>
              <MemberProfiles member={member} callback={() => fetchData(memberId)} />
            </Box>
          )}
        </>
      }
      dialogActions={
        <>
          {!showAddProfile ? (
            <DialogActions>
              <Button onClick={() => setShowAddProfile(true)} color='primary' disabled={isLoading}>
                {t('common:button.yes')}
              </Button>
              <Button autoFocus onClick={onClose} color='primary' variant='contained'>
                {t('common:button.no')}, {t('common:button.cancel')}
              </Button>
            </DialogActions>
          ) : (
            <DialogActions>
              <Button onClick={onClose} color='primary' variant='contained' disabled={isLoading}>
                {t('common:button.done')}
              </Button>
            </DialogActions>
          )}
        </>
      }
    />
  );
};
